"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Store_1 = require("../store/Store");
var legacy_1 = require("satcheljs/lib/legacy");
exports.default = legacy_1.action('setClientOptedIn')(function setOptedIn(optedIn) {
    Store_1.getStore().clientOptedIn = optedIn;
});
//# sourceMappingURL=setClientOptedIn.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/data/owa-mail-store/lib/actions/setClientOptedIn.js
// module id = 3832
// module chunks = 62